import z from 'zod';
export const generateTonProofOutputSchema = z.string();
